module.exports = __webpack_public_path__ + "media/images/flags/ec-eac86ee7c3cc6467b0d5b27c56e1f3b0.svg";